<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.ObjectTypeDialog.Headline' | translate : 'Object type' }}">
    <mat-tab-group>
      <mat-tab label="{{ 'Turbo.Settings.ObjectTypeDialog.tabGeneral' | translate : 'General' }}">
        <div class="row">
          <div class="col-3">
            <img src="data:image/png;base64,{{image.Data}}" style="width: 133px; height: 133px; object-fit: contain;" />
            <input #txtFile type="file" style="visibility:hidden" (change)="upload($event.target.files)" />
            <button mat-mini-fab title="{{ 'Turbo.Settings.EditCategoryDialog.tipChangeImage' | translate : 'Change image' }}" style="position: absolute; left: 61px; bottom: 5px;" (click)="beginUpload()"><mat-icon>autorenew</mat-icon></button>
          </div>

          <div class="col-9">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.ObjectTypeDialog.lblTitle' | translate : 'Title' }}</mat-label>
              <input matInput placeholder="{{ 'Turbo.Settings.ObjectTypeDialog.lblTitle' | translate : 'Title' }}" [(ngModel)]="addonToSave.Title" [disabled]="!data.editable">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.ObjectTypeDialog.lblAlias' | translate : 'Display name' }}</mat-label>
              <input matInput placeholder="{{ 'Turbo.Settings.ObjectTypeDialog.lblAlias' | translate : 'Display name' }}" [(ngModel)]="addonToSave.Alias" [disabled]="!data.editable">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.ObjectTypeDialog.lblobjectTypeClass' | translate : 'Type Class' }}</mat-label>
              <mat-select [ngModel]="addonToSave.TypeClassId" (ngModelChange)="onTypeClassSelected($event)" [disabled]="!data.editable">
                <mat-option *ngFor="let type of objectTypeclasses" [value]="type.Id">
                  {{ type.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <label style="margin-top: 10px">{{ 'turbo.Settings.EditCategoryDialog.lblSortOrder' | translate : 'Sort order' }}: </label><br />
            <mat-slider min="0" max="100" step="1"  discrete style="margin-top: 10px;" [disabled]="!data.editable">
              <input matSliderThumb [(ngModel)]="addonToSave.SortOrder"/>
            </mat-slider>
          </div>

          <div class="col-9">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.ObjectTypeDialog.lblDescription' | translate : 'Description' }}</mat-label>
              <textarea matInput placeholder="{{ 'Turbo.Settings.ObjectTypeDialog.lblDescription' | translate : 'Description' }}" rows="3" [(ngModel)]="addonToSave.Description" [disabled]="!data.editable"></textarea>
            </mat-form-field>
          </div>



          <!--<div class="col-12">
    <mat-form-field appearance="outline" *ngIf="myCategories">
    <mat-label>{{ 'Turbo.Settings.ObjectTypeDialog.Category' | translate : 'Category' }}</mat-label>
     <mat-select [value]="cat" (selectionChange)="setCat($event)" [disabled]="!data.editable">
      <mat-option *ngFor="let c of myCategories" [value]="c">
      <span *ngIf="c.Name.indexOf('Turbo.') >= 0">
      {{ c.Name | translate }}
      </span>
      <span *ngIf="c.Name.indexOf('Turbo.') < 0"> {{ c.Name }}</span>
      </mat-option>
      </mat-select>
    </mat-form-field>
  </div>-->
        </div>
      </mat-tab>
      <mat-tab label="{{ 'Turbo.Settings.ObjectTypeDialog.tabAttributes' | translate : 'Attributes' }}">
        @if(addonToSave.TypeClassId) {
        @for (attr of addonToSave.Attributes; track $index) {
        @if ($index % 2 === 0) {
        <div class="row">
          <div class="col-6">
            <mat-form-field>
              @if (attr.Name) {
              <mat-label>{{ attr.Name | translate }} ({{ attr.Shorthand | translate }})</mat-label>
              } @else {
              <mat-label>{{ attr.Key }}</mat-label>
              }
              <input matInput [(ngModel)]="attr.Value" [disabled]="!data.editable" />
              <span matSuffix>{{ attr.Unit | translate }}</span>
            </mat-form-field>
          </div>

          @if (addonToSave.Attributes[$index + 1]) {
          <div class="col-6">
            <mat-form-field>
              @if (addonToSave.Attributes[$index + 1].Name) {
              <mat-label>
                {{ addonToSave.Attributes[$index + 1].Name | translate }}
                ({{ addonToSave.Attributes[$index + 1].Shorthand | translate }})
              </mat-label>
              } @else {
              <mat-label>{{ addonToSave.Attributes[$index + 1].Key }}</mat-label>
              }
              <input matInput
                     [(ngModel)]="addonToSave.Attributes[$index + 1].Value"
                     [disabled]="!data.editable" />
              <span matSuffix>{{ addonToSave.Attributes[$index + 1].Unit | translate }}</span>
            </mat-form-field>
          </div>
          }
        </div>
        }
        }

        }
      </mat-tab>
    </mat-tab-group>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions *ngIf="data.editable">
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!addonToSave.Title" (click)="save()">{{ 'T4.Settings.CreatePricelistDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="!data.editable">
  <button mat-raised-button color="primary" style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdClose' | translate : 'Close' }}</button>
</mat-dialog-actions>
